class Magma {}

export default new Magma();
